var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "website_3141360 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "website-man-ads-online-graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.4375 5.4375H7.25V7.25H5.4375V5.4375Z",
    fill: "url(#paint0_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.0625 5.4375H10.875V7.25H9.0625V5.4375Z",
    fill: "url(#paint1_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.6875 5.4375H14.5V7.25H12.6875V5.4375Z",
    fill: "url(#paint2_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.6875 27.1875C41.4471 27.1875 41.2166 27.283 41.0467 27.4529C40.8767 27.6229 40.7812 27.8534 40.7812 28.0938V29C40.7812 29.2404 40.8767 29.4709 41.0467 29.6408C41.2166 29.8108 41.4471 29.9062 41.6875 29.9062C41.9279 29.9062 42.1584 29.8108 42.3283 29.6408C42.4983 29.4709 42.5938 29.2404 42.5938 29V28.0938C42.5938 27.8534 42.4983 27.6229 42.3283 27.4529C42.1584 27.283 41.9279 27.1875 41.6875 27.1875Z",
    fill: "url(#paint3_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M47.125 27.1875C46.8846 27.1875 46.6541 27.283 46.4842 27.4529C46.3142 27.6229 46.2188 27.8534 46.2188 28.0938V29C46.2188 29.2404 46.3142 29.4709 46.4842 29.6408C46.6541 29.8108 46.8846 29.9062 47.125 29.9062C47.3654 29.9062 47.5959 29.8108 47.7658 29.6408C47.9358 29.4709 48.0312 29.2404 48.0312 29V28.0938C48.0312 27.8534 47.9358 27.6229 47.7658 27.4529C47.5959 27.283 47.3654 27.1875 47.125 27.1875Z",
    fill: "url(#paint4_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M51.6562 40.7812H48.0312V38.8962C49.132 38.2602 50.0463 37.3461 50.6825 36.2454C51.3187 35.1448 51.6545 33.8963 51.6562 32.625V31.7188H52.5625C53.2829 31.7166 53.9732 31.4295 54.4826 30.9201C54.992 30.4107 55.2791 29.7204 55.2812 29V28.0938C55.2791 27.3734 54.992 26.6831 54.4826 26.1737C53.9732 25.6643 53.2829 25.3772 52.5625 25.375H51.6562V21.75C51.655 21.3698 51.5737 20.9941 51.4175 20.6475C51.2614 20.3008 51.0339 19.991 50.75 19.7381V2.71875C50.75 2.4784 50.6545 2.24789 50.4846 2.07793C50.3146 1.90798 50.0841 1.8125 49.8438 1.8125H2.71875C2.4784 1.8125 2.24789 1.90798 2.07793 2.07793C1.90798 2.24789 1.8125 2.4784 1.8125 2.71875V44.4062C1.8125 44.6466 1.90798 44.8771 2.07793 45.0471C2.24789 45.217 2.4784 45.3125 2.71875 45.3125H32.625V55.2812C32.625 55.5216 32.7205 55.7521 32.8904 55.9221C33.0604 56.092 33.2909 56.1875 33.5312 56.1875H55.2812C55.5216 56.1875 55.7521 56.092 55.9221 55.9221C56.092 55.7521 56.1875 55.5216 56.1875 55.2812V45.3125C56.1875 44.1107 55.7101 42.9582 54.8603 42.1084C54.0106 41.2586 52.858 40.7812 51.6562 40.7812ZM51.6562 27.1875H52.5625C52.8029 27.1875 53.0334 27.283 53.2033 27.4529C53.3733 27.6229 53.4688 27.8534 53.4688 28.0938V29C53.4688 29.2404 53.3733 29.4709 53.2033 29.6408C53.0334 29.8108 52.8029 29.9062 52.5625 29.9062H51.6562V27.1875ZM50.5506 46.6628L46.7806 48.5478L49.6081 43.8444L50.5506 46.6628ZM48.2397 42.5938L46.6084 45.3216L45.6841 44.4062L47.4966 42.5938H48.2397ZM40.5728 42.5938H41.3159L43.1284 44.4062L42.2041 45.3216L40.5728 42.5938ZM42.0319 48.5478L38.2619 46.6628L39.2044 43.8444L42.0319 48.5478ZM42.5938 41.3159V39.6394C43.7817 39.9536 45.0308 39.9536 46.2188 39.6394V41.3159L44.4062 43.1284L42.5938 41.3159ZM49.8438 32.625C49.8438 34.0671 49.2709 35.4502 48.2511 36.4699C47.2314 37.4896 45.8484 38.0625 44.4062 38.0625C42.9641 38.0625 41.5811 37.4896 40.5614 36.4699C39.5416 35.4502 38.9688 34.0671 38.9688 32.625V25.375H49.8438V32.625ZM49.8438 21.75V23.5625H38.0625C37.3421 23.5603 36.6518 23.2732 36.1424 22.7638C35.633 22.2544 35.3459 21.5641 35.3438 20.8438H48.9375C49.1779 20.8438 49.4084 20.9392 49.5783 21.1092C49.7483 21.2791 49.8438 21.5096 49.8438 21.75ZM3.625 3.625H48.9375V9.0625H3.625V3.625ZM33.0056 43.5H3.625V10.875H48.9375V19.0312H34.4375C34.1971 19.0312 33.9666 19.1267 33.7967 19.2967C33.6267 19.4666 33.5312 19.6971 33.5312 19.9375V20.8438C33.5339 21.8876 33.8957 22.8987 34.5558 23.7073C35.2159 24.5159 36.1341 25.0728 37.1562 25.2844V25.375H36.25C35.5296 25.3772 34.8393 25.6643 34.3299 26.1737C33.8205 26.6831 33.5334 27.3734 33.5312 28.0938V29C33.5334 29.7204 33.8205 30.4107 34.3299 30.9201C34.8393 31.4295 35.5296 31.7166 36.25 31.7188H37.1562V32.625C37.158 33.8963 37.4938 35.1448 38.13 36.2454C38.7662 37.3461 39.6805 38.2602 40.7812 38.8962V40.7812H37.1562C36.2753 40.7833 35.414 41.0414 34.6771 41.5241C33.9402 42.0068 33.3595 42.6933 33.0056 43.5ZM37.1562 27.1875V29.9062H36.25C36.0096 29.9062 35.7791 29.8108 35.6092 29.6408C35.4392 29.4709 35.3438 29.2404 35.3438 29V28.0938C35.3438 27.8534 35.4392 27.6229 35.6092 27.4529C35.7791 27.283 36.0096 27.1875 36.25 27.1875H37.1562ZM43.5 54.375H38.9688V51.6562H37.1562V54.375H34.4375V45.3125C34.4397 44.5921 34.7268 43.9018 35.2362 43.3924C35.7456 42.883 36.4359 42.5959 37.1562 42.5938H37.7091L36.2953 46.835C36.2264 47.0417 36.2343 47.2664 36.3175 47.4677C36.4007 47.6691 36.5537 47.8338 36.7484 47.9316L43.5 51.3119V54.375ZM43.1647 46.9256L44.4062 45.6841L45.6478 46.9256L44.4062 48.9919L43.1647 46.9256ZM54.375 54.375H51.6562V51.6562H49.8438V54.375H45.3125V51.3119L52.0641 47.9316C52.2588 47.8338 52.4118 47.6691 52.495 47.4677C52.5782 47.2664 52.5861 47.0417 52.5172 46.835L51.1034 42.5938H51.6562C52.3766 42.5959 53.0669 42.883 53.5763 43.3924C54.0857 43.9018 54.3728 44.5921 54.375 45.3125V54.375Z",
    fill: "url(#paint5_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.5 16.3125H10.875C10.6346 16.3125 10.4041 16.408 10.2342 16.5779C10.0642 16.7479 9.96875 16.9784 9.96875 17.2188V25.375H11.7812V21.75H13.5938V25.375H15.4062V17.2188C15.4062 16.9784 15.3108 16.7479 15.1408 16.5779C14.9709 16.408 14.7404 16.3125 14.5 16.3125ZM11.7812 19.9375V18.125H13.5938V19.9375H11.7812Z",
    fill: "url(#paint6_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.0312 16.3125H17.2188C16.9784 16.3125 16.7479 16.408 16.5779 16.5779C16.408 16.7479 16.3125 16.9784 16.3125 17.2188V24.4688C16.3125 24.7091 16.408 24.9396 16.5779 25.1096C16.7479 25.2795 16.9784 25.375 17.2188 25.375H19.0312C19.7523 25.375 20.4438 25.0886 20.9537 24.5787C21.4636 24.0688 21.75 23.3773 21.75 22.6562V19.0312C21.75 18.3102 21.4636 17.6187 20.9537 17.1088C20.4438 16.5989 19.7523 16.3125 19.0312 16.3125ZM19.9375 22.6562C19.9375 22.8966 19.842 23.1271 19.6721 23.2971C19.5021 23.467 19.2716 23.5625 19.0312 23.5625H18.125V18.125H19.0312C19.2716 18.125 19.5021 18.2205 19.6721 18.3904C19.842 18.5604 19.9375 18.7909 19.9375 19.0312V22.6562Z",
    fill: "url(#paint7_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.9062 13.5938H8.15625C7.43585 13.5959 6.74558 13.883 6.23618 14.3924C5.72678 14.9018 5.43965 15.5921 5.4375 16.3125V25.375C5.43965 26.0954 5.72678 26.7857 6.23618 27.2951C6.74558 27.8045 7.43585 28.0916 8.15625 28.0938H29.9062C30.6266 28.0916 31.3169 27.8045 31.8263 27.2951C32.3357 26.7857 32.6228 26.0954 32.625 25.375V16.3125C32.6228 15.5921 32.3357 14.9018 31.8263 14.3924C31.3169 13.883 30.6266 13.5959 29.9062 13.5938ZM30.8125 25.375C30.8125 25.6154 30.717 25.8459 30.5471 26.0158C30.3771 26.1858 30.1466 26.2812 29.9062 26.2812H8.15625C7.9159 26.2812 7.68539 26.1858 7.51543 26.0158C7.34548 25.8459 7.25 25.6154 7.25 25.375V16.3125C7.25 16.0721 7.34548 15.8416 7.51543 15.6717C7.68539 15.5017 7.9159 15.4062 8.15625 15.4062H29.9062C30.1466 15.4062 30.3771 15.5017 30.5471 15.6717C30.717 15.8416 30.8125 16.0721 30.8125 16.3125V25.375Z",
    fill: "url(#paint8_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M24.4688 18.125V19.9375H27.1875C27.4279 19.9375 27.6584 20.033 27.8283 20.2029C27.9983 20.3729 28.0938 20.6034 28.0938 20.8438V24.4688C28.095 24.5881 28.0723 24.7065 28.0272 24.817C27.9821 24.9275 27.9154 25.0279 27.831 25.1123C27.7466 25.1967 27.6462 25.2634 27.5357 25.3085C27.4252 25.3536 27.3068 25.3762 27.1875 25.375H22.6562V23.5625H26.2812V21.75H23.5625C23.3221 21.75 23.0916 21.6545 22.9217 21.4846C22.7517 21.3146 22.6562 21.0841 22.6562 20.8438V17.2188C22.6562 16.9784 22.7517 16.7479 22.9217 16.5779C23.0916 16.408 23.3221 16.3125 23.5625 16.3125H28.0938V18.125H24.4688Z",
    fill: "url(#paint9_linear_1461_14047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M27.1875 39.875V31.7188C27.1875 31.4784 27.092 31.2479 26.9221 31.0779C26.7521 30.908 26.5216 30.8125 26.2812 30.8125H22.6562C22.4159 30.8125 22.1854 30.908 22.0154 31.0779C21.8455 31.2479 21.75 31.4784 21.75 31.7188V39.875H20.8438V34.4375C20.8438 34.1971 20.7483 33.9666 20.5783 33.7967C20.4084 33.6267 20.1779 33.5312 19.9375 33.5312H16.3125C16.0721 33.5312 15.8416 33.6267 15.6717 33.7967C15.5017 33.9666 15.4062 34.1971 15.4062 34.4375V39.875H14.5V37.1562C14.5 36.9159 14.4045 36.6854 14.2346 36.5154C14.0646 36.3455 13.8341 36.25 13.5938 36.25H9.96875C9.7284 36.25 9.49789 36.3455 9.32793 36.5154C9.15798 36.6854 9.0625 36.9159 9.0625 37.1562V39.875H7.25V41.6875H29V39.875H27.1875ZM12.6875 39.875H10.875V38.0625H12.6875V39.875ZM19.0312 39.875H17.2188V35.3438H19.0312V39.875ZM25.375 39.875H23.5625V32.625H25.375V39.875Z",
    fill: "url(#paint10_linear_1461_14047)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1461_14047",
    x1: -21.6621,
    y1: 36.0298,
    x2: 32.238,
    y2: -21.1048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1461_14047",
    x1: -19.7445,
    y1: 37.8396,
    x2: 34.1566,
    y2: -19.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1461_14047",
    x1: -17.8259,
    y1: 39.6484,
    x2: 36.0742,
    y2: -17.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1461_14047",
    x1: 8.12091,
    y1: 64.1272,
    x2: 62.0219,
    y2: 6.99263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1461_14047",
    x1: 10.9982,
    y1: 66.8414,
    x2: 64.8984,
    y2: 9.70684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1461_14047",
    x1: 1.63397,
    y1: 58.0072,
    x2: 55.535,
    y2: 0.873625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1461_14047",
    x1: -10.9312,
    y1: 46.1535,
    x2: 42.9689,
    y2: -10.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1461_14047",
    x1: -7.98497,
    y1: 48.933,
    x2: 45.9161,
    y2: -8.20156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1461_14047",
    x1: -7.71128,
    y1: 49.1912,
    x2: 46.1888,
    y2: -7.94328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1461_14047",
    x1: -4.35362,
    y1: 52.3586,
    x2: 49.5474,
    y2: -4.77503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1461_14047",
    x1: 1.47266,
    y1: 57.855,
    x2: 55.3728,
    y2: 0.720471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD118C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsit);
export default __webpack_public_path__ + "static/media/websit.03b3a7ba7f40e6b081d05fd41be10d1c.svg";
export { ForwardRef as ReactComponent };